import { Helmet } from "react-helmet-async"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../../Auth"
import { TouristsList } from "../../../../../Tourists"

export default function OrganizationTouristsAllPage() {
	return (
		<>
			<Helmet>
				<title>All Tourists</title>
			</Helmet>
			<ForbidUnlessAuthorized permission={PERMISSIONS.MANAGE_USERS}>
				<TouristsList />
			</ForbidUnlessAuthorized>
		</>
	)
}
